import { HashLink as Link } from "react-router-hash-link";
import { getLocaleFromPath, localePath } from "../i18n/config";

const ServicesInfo2 = () => {
    const locale = getLocaleFromPath();
    const tabletBelow = locale === "en" ? "/assets/images/en/tablet-below.jpg"
        : locale === "sv" ? "/assets/images/sv/tablet-below.jpg"
        : "/assets/images/services/senioritabletti.webp";

    return (
        <>
            <div className="global-box-line-container">
                <div className="global-box-line">
                    <div className="global-box global-background-gray">
                        <div className="services-info-title">Tabletti, jalusta, liittymä</div>
                        <ul className="services-info-text">
                            <li>Ei tavallinen Samsung-tabletti, tehty aidosti helpoksi käyttää</li>
                            <li>Jalusta – useita malleja</li>
                            <li>Liittymä – rajaton data</li>
                            <li>Teknisesti muokattu: isot kuvakkeet ja kotinäppäin, ei skrollaa, selkeä ääni, ei salasanoja. Ei käänny.</li>
                            <li>
                                Sisältö yksilöllisesti. Vain videopuhelut tai lisäksi radiot, maksuttomat äänikirjat, pelit, uutiset, YleAreena.{" "}
                                <Link className="lue-lisää-linkki" to={`${localePath("senioritabletti")}#palveluvertailu`}>
                                    <strong>Lue lisää</strong>
                                </Link>
                            </li>
                        </ul>
                    </div>
            <div className="global-image-container">
              <img src={tabletBelow} alt="Henkilö käyttää tablettia ja kosketusnäyttökynää." className="global-image" />
                    </div>
                </div>
                <div className="global-box-line">
            <div className="global-image-container">
              <img src="/assets/images/services/seniortablet.jpg" alt="Nainen käyttää tablettia maatessaan sängyssä" className="global-image" />
                    </div>
                    <div className="global-box global-background-gray">
                        <div className="services-info-title">Videopuhelut, jotka avautuvat myös automaattisesti</div>
                        <ul className="services-info-text">
                            <li>Digihappy videoappi on seniorilla tabletissa ja läheisellä kännykässä</li>
                            <li>
                                Kun läheinen soittaa, seniorin video avautuu haluttaessa automaattisesti –{" "}
                                <Link className="lue-lisää-linkki" to={`${localePath("senioritabletti")}#vertailutaulukko`}>
                                    <strong>Katso video</strong>
                                </Link>
                            </li>
                            <li>Perhetili, johon saat kuusi läheistä tai ystävää</li>
                            <li>Turvallinen, vain perhetilin jäsenet voivat soittaa</li>
                        </ul>
                    </div>
                </div>
                <div className="global-box-line">
                    <div className="global-box global-background-gray">
                        <div className="services-info-title">Valmiiksi asennettu, jatkuva it-tuki</div>
                        <ul className="services-info-text">
                            <li>Valmiiksi asennettu yksilöllisesti</li>
                            <li>Aloitusneuvonta</li>
                            <li>Jatkuva it-tuki ja etähallinta</li>
                            <li>Tietoturva ja päivitykset</li>
                        </ul>
                    </div>
            <div className="global-image-container">
              <img src="/assets/images/services/ittuki-seniorille.webp" alt="Kaksi naista istuu sohvalla keskittyneinä tabletin näyttöön. He soittavat it-tuelle." className="global-image" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServicesInfo2;
